/* eslint-disable @typescript-eslint/no-magic-numbers */

export class PhoneUtils {
	static cellphonePattern: string = '\\([0-9]{2}\\) [0-9]{5}-[0-9]{4}';
	static dataLength = {
		withDdd: 11,
	}; // (00) 0000-0000
	static ddiPattern: string = '\\+[0-9]{2} \\([0-9]{2}\\) [0-9]{5}-[0-9]{4}'; // (00) 00000-0000
	static onlyDigitsPattern: string = '[0-9]{10,11}'; // +00 (00) 00000-0000
	static phonePattern: string = '\\([0-9]{2}\\) [0-9]{4}-[0-9]{4}';
	// eslint-disable-next-line perfectionist/sort-classes
	static pattern: string = `^(${this.onlyDigitsPattern}|${PhoneUtils.phonePattern}|${PhoneUtils.cellphonePattern}|${PhoneUtils.ddiPattern})$`;

	static phoneMask(phoneNumber: string): string {
		phoneNumber = this.sanitize(phoneNumber);

		switch (phoneNumber.length) {
			case 10:
				return '(00) 0000-00009';
			case 11:
				return '(00) 00000-0000';
			case 13:
				return '+00 (00) 00000-0000';
			default:
				return '(00) 0000-0000';
		}
	}

	static sanitize(phoneNumber: string): string {
		return phoneNumber.replace(/\D/g, '');
	}

	static sanitizePhoneNumber(phone: string): string | null {
		if (phone) {
			let sanitizedPhone = PhoneUtils.sanitize(phone);

			if (
				sanitizedPhone.length > PhoneUtils.dataLength.withDdd &&
				sanitizedPhone.startsWith('55')
			) {
				sanitizedPhone = sanitizedPhone.replace('55', '');
			}

			return sanitizedPhone;
		} else {
			return null;
		}
	}
}
